import { gql } from '@apollo/client';

export default class SMSMutate {
    static SEND_MESSAGE_FROM_CRM = gql`
        mutation sendMessageFromCRM($input: CRMMessageInput!) {
            sendMessageFromCRM(input: $input)
        }
    `;
}
